exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rfbadge{border-radius:.25rem;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}.rfbadge-medium{padding-top:.25rem;padding-bottom:.25rem;padding-left:.5rem;padding-right:.5rem}.rfbadge-processing{background-color:#ebf4fe;color:#0171e2 !important}.rfbadge-success{background-color:#e9f7ef;color:#239754 !important}.rfbadge-failed{background-color:rgba(235,87,87,.1019607843);color:#eb5757 !important}.rfbadge-canceled{background-color:#f2f2f2;color:#7b7b7b !important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/payment-processing/styles/RFBadge.scss
// module id = 5966
// module chunks = 0